import React from 'react';
import PropTypes from 'prop-types';
import { Card, SmallText, Paragraph } from '../../../legacy/hui/src/styled';
import InviteVis from '../InviteVis';
import ShadowCard from '../ShadowCard';
import Measure from 'react-measure';
import ErrorBoundary from '../ErrorBoundary';
import styled from 'styled-components';
import moderationTickIcon from '../../images/moderation-tick-icon.svg';

const ContactText = styled(SmallText)`
  border-top: 1px solid #ececec;
  margin: 0 -1rem;
  padding: 10px 20px 0;
  opacity: 0.3;
  transition: opacity 0.6s;
  text-align: center;
`;

export default class InvitingNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animationFinished: false
    };
  }

  onAnimationFinished = () => {
    this.setState({
      animationFinished: true
    });
  };

  static propTypes = {
    style: PropTypes.object,
    categoryPerson: PropTypes.string,
    personPlural: PropTypes.string,
    suburb: PropTypes.string,
    invitedCount: PropTypes.number,
    thumbnails: PropTypes.arrayOf(PropTypes.string),
    onAnimationStarted: PropTypes.func,
    fetchJobInvitations: PropTypes.func,
    hasSeenAnimation: PropTypes.bool
  };

  render() {
    const {
      categoryPerson,
      personPlural,
      thumbnails,
      invitedCount,
      hasSeenAnimation,
      onAnimationStarted,
      fetchJobInvitations,
      ...rest
    } = this.props;

    return (
      <ShadowCard p={0} snow {...rest}>
        <Card.Section p={1}>
          <Paragraph
            style={{ lineHeight: '1.3', maxWidth: '85%', margin: '0 auto' }}
            mb={0.4}
            secondaryDark
            center
          >
            {`Job posted! We're alerting qualified ${personPlural}`}
          </Paragraph>
          <ErrorBoundary name={'Inviting Visualisation'} style={{ marginBottom: '1rem' }}>
            <Measure client>
              {({ measureRef, contentRect = { client: { width: 400 } } }) => (
                <div ref={measureRef} key={'invite-vis'}>
                  <InviteVis
                    max={Math.floor(contentRect.client.width / 48)}
                    thumbnails={thumbnails}
                    invitedCount={invitedCount}
                    hasSeenAnimation={hasSeenAnimation}
                    onAnimationStarted={onAnimationStarted}
                    onAnimationFinished={this.onAnimationFinished}
                    fetchJobInvitations={fetchJobInvitations}
                  />
                </div>
              )}
            </Measure>
          </ErrorBoundary>
          <div
            style={{
              transition: 'height 0.2s ease-out',
              height: this.state.animationFinished ? '51px' : 0
            }}
          >
            <ContactText
              mb={0}
              pr={0.1}
              pl={0.1}
              center
              style={{ opacity: this.state.animationFinished ? 1 : 0 }}
            >
              <img src={moderationTickIcon} style={{ margin: '-1px 5px -1px 0' }} />
              {`Your connected ${categoryPerson} will contact you shortly!`}
            </ContactText>
          </div>
        </Card.Section>
      </ShadowCard>
    );
  }
}
